import { connect } from "react-redux";
import { utcOffset } from "../../utils/time";
import { TRACK_EDIT_TIMEZONE, callOnlyOnce } from "../../store/mixpanel";
import setSystemTimezone from "../../store/epics/setSystemTimezone";
import updateTimezone from "../../store/epics/updateTimezone";
import dotFlowCallback from "../../store/epics/dotFlowCallback";
import closeWebview from "../../store/epics/closeWebview";

const updateTimezoneTutorialEpic = timezone => (dispatch, getState) => {
  return dispatch(updateTimezone({ timezone }))
    .then(() => dispatch(dotFlowCallback("___TIMEZONE_CONFIRM___")))
    .then(() => dispatch(closeWebview()))
    .catch(err => {
      console.log(err);
    });
};

export default connect(
  ({
    user: {
      data: { _id, timezone = utcOffset(), tutorial_status }
    }
  }) => ({ _id, timezone, tutorial_status }),
  dispatch => {
    const trackTz = callOnlyOnce(timezone => {
      dispatch({
        type: TRACK_EDIT_TIMEZONE,
        payload: { timezone, from: "route" }
      });
    });
    return {
      updateTimezone(timezone) {
        trackTz(timezone);
        return dispatch(updateTimezoneTutorialEpic(timezone));
      },
      setSystemTimezone() {
        return dispatch(setSystemTimezone());
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/routes/Timezone/connected.js